module.exports = __webpack_public_path__ + "img/button-center-green.73da708.png";